'use client';

import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Icon,
  HStack,
  Box,
  Spinner,
  Center,
} from '@chakra-ui/react';
import { useUIStore } from '~/store/useUIStore';
import { useState } from 'react';
import { MdAccountCircle } from 'react-icons/md';

export const ClientPortalDrawer = () => {
  const modals = useUIStore((state) => state.modals);
  const setModals = useUIStore((state) => state.setModals);
  const [isLoading, setIsLoading] = useState(true);

  const onClose = () => {
    setModals({ ...modals, clientPortalOpen: false });
  };

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <Drawer
      isOpen={modals.clientPortalOpen}
      placement="right"
      onClose={onClose}
      size={{ base: 'full', md: 'md' }}
      closeOnOverlayClick={true}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton
          size="lg"
          top="4"
          right="4"
          _hover={{
            backgroundColor: 'blackAlpha.200',
          }}
        />
        <DrawerHeader
          borderBottomWidth="1px"
          borderBottomColor="blackAlpha.200"
          py="6"
        >
          <HStack spacing="3">
            <Icon as={MdAccountCircle} boxSize="24px" color="blackAlpha.700" />
            <Text fontSize="xl" fontWeight="semibold" color="blackAlpha.900">
              Mina sidor
            </Text>
          </HStack>
        </DrawerHeader>

        <DrawerBody px="0" py="0" position="relative" overflow="hidden">
          {isLoading && (
            <Center
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bg="white"
              zIndex={1}
            >
              <Spinner size="xl" color="brand.500" thickness="4px" />
            </Center>
          )}
          <Box
            as="iframe"
            src="https://minasidor.erikolsson.se"
            width="100%"
            height="100%"
            border="none"
            title="Mina sidor"
            onLoad={handleIframeLoad}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
